"use client";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

// Register plugins once — safe to call multiple times
gsap.registerPlugin(ScrollTrigger, useGSAP);

// Project-wide defaults matching design system easing
gsap.defaults({
  duration: 0.7,
  ease: "power3.out",
});

export { gsap, ScrollTrigger, useGSAP };
